import {Sort} from './filter/sort';
import {Filter} from './filter/filter';

/**
 * Helper model for using sorting and filtering
 *
 * # Sample Usage:
 * ```ts
 *  const builder = new Builder();
 *  builder.sort = new Sort('name', 'asc');
 *  builder.filters.push(new Filter('name', [vm.entityCall.options['filter[name]']]));
 *  this.groupsService.everything(builder).then(data => {
 *    this.groups = data;
 *  });
 * ```
 */
export class Builder {
  public sort: Sort;
  public filters: Array<Filter> = [];
  public params: Object         = {}; // Additional parameters given

  addFilter(name, values: any[]) {
    const filter = new Filter(name, values);
    this.filters.push(filter);
  }

  clearFilters() {
    this.filters = [];
  }

  /**
   *
   * @param includeQ - include question mark, ie. ?a=b&c=d
   */
  public buildUrl(includeQ: boolean = false) {
    const builder   = this;
    const opts      = [];
    let queryString = '';

    for (const key in builder.params) {
      if (builder.params.hasOwnProperty(key)) {
        opts.push(key + '=' + builder.params[key]);
      }
    }

    // Add sorting properties
    if (builder.sort != null) {
      let direction = '';
      switch (builder.sort.direction) {
        case '-':
        case 'desc':
          direction = '-';
          break;
      }

      opts.push('sort=' + direction + builder.sort.field); // Add better checks for this field
    }

    for (const filter of builder.filters) {
      opts.push('filter[' + filter.field + ']=' + filter.values.join(',')); // URL Encode
    }

    if (includeQ) {
      if (opts.length > 0) {
        queryString = '?' + opts.join('&');
      }
    } else {
      if (opts.length > 0) {
        queryString = opts.join('&');
      }
    }

    return queryString;
  }
}
